import{a as e,b as i}from"./chunk-6REMSCKD.js";import{g as a}from"./chunk-FC3CZOOQ.js";import{a as o,m as r}from"./chunk-HBP5N4FR.js";r();import n from"axios";var f=t=>{let m=i(t);return n.get(`${t.apiAddress}/${a}`,o({params:m},e(t.apiTimeout)))};export{f as a};
//# sourceMappingURL=chunk-MYJG7BOH.js.map
